import { ModalStates } from '@components'

import { ConfirmationModalBody } from '../elements/ConfirmationModalBody'
import { ConfirmationModalFooter } from '../elements/ConfirmationModalFooter'
import { ErrorModalBody } from '../elements/ErrorModalBody'
import { ProcessingModalBody } from '../elements/ProcessingModalBody'
import { SuccessModalBodyNewFlow } from '../elements/SuccessModalBodyNewFlow'
import { CreateBankConnectionModalSteps } from '../enums/createBankConnectionModalSteps'

export const createBankConnectionModalSteps: ModalStates<CreateBankConnectionModalSteps> = [
  {
    id: CreateBankConnectionModalSteps.Confirmation,
    headerTKey: 'bank_connection.shine_connect_modal.title',
    modalBody: <ConfirmationModalBody />,
    modalFooter: <ConfirmationModalFooter />,
  },
  {
    id: CreateBankConnectionModalSteps.Processing,
    modalBody: <ProcessingModalBody />,
  },
  {
    id: CreateBankConnectionModalSteps.SuccessNewFlow,
    modalBody: <SuccessModalBodyNewFlow />,
  },
  {
    id: CreateBankConnectionModalSteps.Error,
    modalBody: <ErrorModalBody />,
  },
]
